module.exports = __webpack_public_path__ + "k-icons.1647893750196.svg";